import { Address } from './address.model';
import { LegalEntityDocumentTypeName } from './legal-entity-document.model';
import { IMember, Member } from './member.model';
import { NaturalPersonRelatedMemberType } from './natural-persons-info-none-voting.model';

export class CompanyIdentification {
  name: string;
  neq: string;
  address: Address;

  static get empty(): CompanyIdentification {
    return {
      name: '',
      neq: '',
      address: Address.empty,
    };
  }
}

export enum OtherNameOperation {
  None, Add, Remove,
}

export enum EstablishmentMemberResponsibility {
  Primary = 'Primary',
  Substitute = 'Substitute',
  PrimaryEstablisment = 'PrimaryEstablisment',
  None = 'None',
}

export enum EstablishmentMemberState {
  Owner = 'Owner',
  EmployeeSelfEmployed = 'EmployeeSelfEmployed',
  Shareholder = 'Actionnaire'
  //Other = 'Other', //Je ne sais pas
}

export enum EstablishmentMemberStatePlatine {
  Administrator = 'Administrator',
  Employee = 'Employee',
  SelfEmployed = 'SelfEmployed'
}

export class CompanyRepresentative extends Member {
  response: string;
}

export class CompanyEstablishmentMember extends Member {
  state: string;
  responsibility: string;

  modificationType: string
  modificationEffectiveDate: Date;
}

export class CompanyOtherName {
  id: string;
  name: string;
  startDate: Date;
  endDate: Date;

  static get empty(): CompanyOtherName {
    return {
      id: '',
      name: '',
      startDate: new Date(),
      endDate: new Date(),
    };
  }
}

export class CompanyRepresentativeSubstitute {
  representative: CompanyRepresentative;
  substitute: CompanyRepresentative;
  certified: boolean;
  attestationDate: Date;

  static get empty(): CompanyRepresentativeSubstitute {
    return {
      representative: new CompanyRepresentative(),
      substitute: new CompanyRepresentative(),
      certified: false,
      attestationDate: new Date(),
    };
  }
}

export class BaseShareholder {
  startDate: string;
  endDate: string;
  sharePercentage: number;
  address: Address;

  constructor() {
    this.startDate = '';
    this.endDate = '';
    this.sharePercentage = null;
    this.address = new Address();
  }
}

export class ShareHolderMember extends BaseShareholder implements IMember {
  permitNumber: string;
  firstName: string;
  lastName: string;
  confirmation: AttestationType;

  constructor() {
    super();
    this.permitNumber = '';
    this.firstName = '';
    this.lastName = '';
  }
}

export enum AttestationType {
  ActiveMember = 'ActiveMember',
  InactiveMember = 'InactiveMember',
}

export interface INaturalPerson {
  relatedMember: Member;
  relationType: string;
  firstName: string;
  lastName: string;

}

export class NaturalPerson implements INaturalPerson {
  relatedMember: Member;
  relationType: string;
  firstName: string;
  lastName: string;

  constructor() {
    this.relatedMember = new Member();
    this.relationType = '';
    this.firstName = '';
    this.lastName = '';
  }
}

export class ShareHolderNaturalPerson extends BaseShareholder implements INaturalPerson {
  relatedMember: Member;
  relationType: NaturalPersonRelatedMemberType;
  firstName: string;
  lastName: string;
  constructor() {
    super();
    this.relatedMember = new Member();
    this.relationType = null;
    this.firstName = '';
    this.lastName = '';
  }
}

export class LegalPerson extends BaseShareholder {
  name: string;
  neq: string;
  type: string;
  members: Member[];
  naturalPersons: NaturalPerson[];
  numberOfTrustees: number;

  constructor() {
    super();
    this.name = '';
    this.neq = '';
    this.type = '';
    this.members = [];
    this.naturalPersons = [];
    this.numberOfTrustees = null;
  }

}

export class CompanyNonVotingNaturalPersons {
  members: ShareHolderMember[];
  naturalPersons: ShareHolderNaturalPerson[];
}

// Etablishment =======================
export enum OtherEstablishmentOperation {
  None, Addition, Deletion, Amendment,
}

export class CompanyOtherEstablishment {
  name: string;
  address: Address;
  members: CompanyEstablishmentMember[];
  exploitedByLegalEntity: boolean;
}

export class CompanyOtherEstablishmentFirebase {
  legalName: string;
  address: Address;
  members: CompanyEstablishmentMember[];
  exploitedByLegalEntity: boolean;
}

// Member List in establishment ========
export interface IMemberEstablishment {
  firstName: string;
  lastName: string;
  permitNumber: string;
  status: string;
  operation: OtherEstablishmentOperation;
  responsibility: EstablishmentMemberResponsibility;
  state: EstablishmentMemberState;
}

// Attached Documents
export class AttachedDocuments {
  documentId: string;
  documentType: LegalEntityDocumentTypeName;
  downloadLink: string;
  fileName: string;
  uploadedBy: string;
}

export class PartnershipCompany {
  name: string;
  neq: string;
}

export class MainPartnershipCompany extends PartnershipCompany {
  dateOfAmalgamation: string;
}

export class CompanyAmalgamation {
  partnershipCompany: MainPartnershipCompany;
  otherPartnershipCompany: PartnershipCompany[];
}

export enum ModificationTypes {
  None = 'none',
  Add = 'add',
  Delete = 'delete',
  Modification = 'modification'
};